import React, { useEffect, useState } from 'react';
import ZAppBar from '../components/ZAppBar';
import FullscreenOutlined from '@material-ui/icons/FullscreenOutlined';
import FullscreenExitOutlined from '@material-ui/icons/FullscreenExitOutlined';
import ZToolBar from '../components/ZToolBar';
import ZIconButton from '../components/ZIconButton';
import ZTypography from '../components/ZTypography';
import MoreIcon from '@material-ui/icons/MoreVert';
import ZListItem from '../components/ZListItem';
import ZList from '../components/ZList';
import ZListItemIcon from '../components/ZListItemIcon';
import ZListItemText from '../components/ZListItemText';
import UserMenu from './ZUserMenu';
import Sidebar from '../components/ZSideBar';
import { withStyles } from '@material-ui/core/styles';
import PersonIcon from '@material-ui/icons/Person';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Tooltip from '@material-ui/core/Tooltip';
import logo from '../asset/images/banklogo.png';
import profilePic from '../asset/images/VkenLogo.png'
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import SvgIcon from '@mui/material/SvgIcon';
import InboxIcon from '@mui/icons-material/MoveToInbox';
// import List from '@mui/material/List';
// import ListItem from '@mui/material/ListItem';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
import MailIcon from '@mui/icons-material/Mail';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import ZGrid from '../components/ZGrid';
import { styled, alpha } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import Avatar from '@mui/material/Avatar';
import { grey } from '@mui/material/colors';
import AccountBalanceSharpIcon from '@mui/icons-material/AccountBalanceSharp';
import TransformSharpIcon from '@mui/icons-material/TransformSharp';
import LogoutSharpIcon from '@mui/icons-material/LogoutSharp';
import { Redirect } from 'react-router';
import Dashboard from "../containers/Dashboard";
import FundTransfer from '../containers/FundTransfer';
import Transaction from '../containers/Transaction';
import { Switch, Route, BrowserRouter } from 'react-router-dom'
import Hidden from '@mui/material/Hidden';
import MenuItem from '@mui/material/MenuItem';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';

const elem = document.documentElement;
const drawerWidth = 240;

function PrimarySearchAppBar(props) {
  const classes = props.classes
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const handleOnClick = index => {
    setSelectedIndex(index);
  };

  useEffect(() => {
    if ((props.history.location.pathname).toUpperCase() == '/DASHBOARD') {
      setSelectedIndex(0);
    } else if ((props.history.location.pathname).toUpperCase() == '/FUNDTRANSFER') {
      setSelectedIndex(1);
    }
  });


  const drawer = (
    <div>
      <Toolbar />
      {/* <Divider /> */}
      <ZList className={classes.menuList}>
        {['Accounts', 'Transfer', 'Logout',].map((text, index) => (
          <ZListItem button key={index} onClick={() => handleOnClick(index)} className={selectedIndex === index ? classes.active : classes.listItem}>
            {index == 0 ?
              <ZListItemIcon className={classes.listItemIcon} onClick={() => props.history.push("/dashboard")}>
                {index == 0 ? <AccountBalanceSharpIcon /> : ''}

                <ZListItemText primary={text} className={classes.listItemText} />

              </ZListItemIcon> : ''
            }


            {index == 1 ?
              <ZListItemIcon className={classes.listItemIcon} onClick={() => props.history.push("/fundtransfer")}>
                {index == 1 ? <TransformSharpIcon /> : ''}

                <ZListItemText primary={text} className={classes.listItemText} />
              </ZListItemIcon> : ''
            }


            {index == 2 ?
              <ZListItemIcon className={classes.listItemIcon} onClick={() => props.history.push("/")}>
                {index == 2 ? <LogoutSharpIcon /> : ''}

                <ZListItemText primary={text} className={classes.listItemText} />
              </ZListItemIcon> : ''
            }
          </ZListItem>
        ))}

        {/* <ZListItem button key={index}  onClick={() => {handleOnClick(index); props.history.push("/dashboard")}}
           className={selectedIndex === index ? "active" : "unactive" ? "listItem" : "listItem"}
        
        >
        <ZListItemIcon className={classes.listItemIcon} >
            <AccountBalanceSharpIcon />
            </ZListItemIcon>
            <ZListItemText  className={classes.listItemText} primary="Accounts" />
          </ZListItem>
          <ZListItem button key={index}  onClick={() => {handleOnClick(index); props.history.push("/fundTransfer")}}>
          <ZListItemIcon className={classes.listItemIcon} >
            <TransformSharpIcon />
            </ZListItemIcon>
            <ZListItemText  className={classes.listItemText} primary="Transfer" />
          </ZListItem>
          <ZListItem buttonkey={index}  onClick={() => {handleOnClick(index);props.history.push("/")}}>
          <ZListItemIcon className={classes.listItemIcon}>
            <LogoutSharpIcon />
            </ZListItemIcon>
            <ZListItemText  className={classes.listItemText} primary="Logout" />
          </ZListItem> */}
      </ZList>


    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;
  const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  }));

  const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }));

  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '20ch',
      },
    },
  }));


  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <ZAppBar className={classes.appBar}
        position="fixed"
        sx={{ width: `calc(100% - ${drawerWidth}px)`, ml: `${drawerWidth}px` }}
      >
        <Toolbar className={classes.toolBar}>

          <ZIconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
            className={classes.iconButton}
          >
            <MenuIcon />
          </ZIconButton>
          <ZGrid style={{ flex: 1 }}>
            <div className={classes.logo}>
              <div className={classes.logoContainer}>
                <img src={logo} />
              </div>
            </div>
          </ZGrid>

          {/* <Hidden xsDown>
            <div>
                <Search>
                  <SearchIconWrapper>
                    <SearchIcon />
                  </SearchIconWrapper>
                  <StyledInputBase
                    placeholder="Search…"
                    inputProps={{ 'aria-label': 'search' }}
                  />
                </Search>
            </div>
          </Hidden> */}

          {/* <ZGrid item md={5}  style={{flex:1}}></ZGrid> */}
          <ZGrid item md={2} className={classes.avatar}>
            <img src={profilePic} className={classes.Profilelogo} />
            {/* <Avatar sx={{ bgcolor: "#F6F5F0", color: "#92278F" }}>J</Avatar> */}
          </ZGrid>
        </Toolbar>
      </ZAppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'block', md: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'none', md: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
}

const styles = (theme) => ({
  appBar: {
    position: "fixed",
    zIndex: theme.zIndex.drawer + 100,
    display: "flex",
    background: "rgb(255, 255, 255)",
    boxShadow: "0 3px 10px rgb(0 0 0 / 20%)",
    [theme.breakpoints.up('md')]: {
      '& .MuiToolbar-root': {
        padding: 0,
        height: 70
      }
    }
  },

  menuList: {
    [theme.breakpoints.up('md')]: {
      paddingTop: 12
    }
  },
  Profilelogo: {
    height: 45,
  },

  dflex: {
    display: "flex",
    '& .MuiButton-root': {
      marginTop: "12px !important"
    }
  },
  GridContainer: {
    minHeight: 90
  },

  iconButton: {
    [theme.breakpoints.up('md')]: {
      display: "none",
      '& .MuiSvgIcon-root': {
        display: "none"
      }
    }
  },


  userWelcome: {
    display: "flex",
    alignItems: "center",
    marginLeft: 10,
    fontWeight: 600,
    textTransform: "uppercase",
    color: "#212529"
  },

  cardHeader: {
    fontWeight: 600,
    textTransform: "uppercase",
    color: "#212529",
    marginBottom: 20
  },

  cardSubHeader: {
    textTransform: "uppercase",
    color: "#212529",
    fontSize: 14,
    padding: "20px 0px 10px 0px",
    fontWeight: 600
  },

  cardContent: { minHeight: 60 },

  avatar: {
    justifyContent: "flex-end",
    display: "flex",
    marginRight: 15,
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
    },
  },

  profileCard: {
    boxShadow: "0 20px 27px 0 rgb(0 0 0 / 5%) !important",
    borderRadius: "0.75rem !important"
  },

  listItemIcon: {
    minWidth: "100%",
    '& .MuiSvgIcon-root': {
      fill: "#303778",
      display: "flex",
      alignItems: "center",
      width: "1.5em",
      height: "1.5em",
      background: "#92278F",
      fill: "#fff",
      borderRadius: "0.5rem",
      padding: 5,
      boxShadow: "0 0.25rem 0.375rem -0.0625rem rgb(20 20 20 / 12%), 0 0.125rem 0.25rem -0.0625rem rgb(20 20 20 / 7%) !important"
    }
  },

  listItemText: {
    marginLeft: 30,
    margin: "0px 0px 0px 30px",
    display: "flex",
    alignItems: "center",

    '& span.MuiTypography-root': {
      color: "#92278F",
      fontFamily: 'Noto Sans'
    }
  },

  listItem: {
    padding: "10px 18px",
    '&:hover': {
      paddingRight: 0,
      borderRadius: "0.75rem",
      background: "#FFF8FF",
      '& span.MuiTypography-root': {
        fontWeight: 600
      }
    },
  },

  active: {
    background: "#FFF8FF",
    padding: "10px 18px",
    '& span.MuiTypography-root': {
      fontWeight: 600,
      fontFamily: 'Noto Sans '
    }
  },

  menuContent: {
    '& .MuiToolbar-root': {
      minHeight: 90
    },

    '& .MuiPaper-root': {
      borderRight: "none",
    }
  },

  rightContent: {
    '& .MuiToolbar-root': {
      minHeight: 90
    }
  },

  logo: {
    margin: "20px !important",
    margin: "0px !important"
  },

  logoContainer: {
    padding: "0 18px",
    margin: "4px auto 0px auto",
    '& img': {
      height: "4rem",
      width: "auto",
      userSelect: "none",
      margin: "0px auto",
    },
    [theme.breakpoints.down('sm')]: {
      margin: 0,
    },
  },


  txtWelcome: {
    fontWeight: 600,
    fontSize: 16,
    margin: 15,
    textTransform: "uppercase",
    fontFamily: "Noto Sans",
    color: "#000000",
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      fontSize: 11,
    },
  },
})


export default withStyles(styles)(PrimarySearchAppBar);